
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from 'store/actions/index';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as DataUtil from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';
import { CustomAppEventListener }
    from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController';
import appsConfigData from 'Flow2/components/CustomCollections/CustomDataJson/appsconfig.json';
import dataconfig from 'Flow2/components/CustomCollections/CustomDataJson/masterconfig.json';

export const getApiData = (obj, option) => {
    let dataArr = [];
    let showData = [];

    if (obj && obj.hasOwnProperty('Levels')) {
        dataArr = [...obj.Levels];
        if (option !== 'contents') {
            for (let i = 0; i < dataArr.length; i++) {
                if (dataArr[i].Levels) {
                    let data = [];
                    if (dataArr[i].hasOwnProperty('Levels')) {
                        data = [...dataArr[i].Levels];

                        if (((dataArr[i].HideLevel !== 1) && (dataArr[i].HideLevel !== "1")) && ((dataArr[i].HideLevel !== 2) && (dataArr[i].HideLevel !== "2")) && option == CustomTypes.API_MODELS) {
                            showData.push(dataArr[i]);
                            dataArr[i].showmodel = true;
                        }
                        for (let j = 0; j < data.length; j++) {
                            if (option === CustomTypes.API_TAGS) {
                                let tags = [];
                                tags = [...data[j].Levels];
                                for (let k = 0; k < tags.length; k++) {
                                    if (((tags[k].HideLevel !== 1) && (tags[k].HideLevel !== "1")) && ((tags[k].HideLevel !== 2) && (tags[k].HideLevel !== "2"))) {
                                        showData.push(tags[k]);
                                    }
                                }
                            } else if ((option === "derivates") || (option === CustomTypes.API_MODELS)) {
                                if (((data[j].HideLevel !== 1) && (data[j].HideLevel !== "1")) && ((data[j].HideLevel !== 2) && (data[j].HideLevel !== "2"))) {
                                    showData.push(data[j]);
                                }
                            }
                        }
                    }
                }
            }
        } else {
            return dataArr;
        }
    }
    return showData;
}

export const getSelectedTags = (data, props) => {
    data = data || "";
    if ((data !== undefined) && (data !== "") && (data.length >= 1)) {
        let selectedTags = [];
        data.map((item) => { selectedTags.push(item[props]); });
        return selectedTags.join(';');
    }
    return data;
}

class ApiTags extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        try {
            this.props.loadUsers();
            if (CustomTypes.CONFIG_FILE) {
                import(`${process.env.REACT_APP_APPID}/config/MetadataConfig`).then(element => {
                    //let formTabs = DataUtil.searchTabs4Form(element.clip);
                    let formTabs = CustomAppEventListener("getFormTabs", element.clip);
                    let uploadConfig = [];
                    let expertSearchConfig = [];
                    let tempConfig = [];

                    // Upload
                    uploadConfig = CustomAppEventListener("initFormData", CustomTypes.APP_FORM_UPLOAD, element.clip, formTabs, this.props.user);
                    if (uploadConfig) this.props.addApiUploadConfig(uploadConfig);

                    //Search
                    expertSearchConfig = CustomAppEventListener("initFormData", CustomTypes.APP_FORM_SEARCH, element.clip, formTabs, this.props.user);
                    if (expertSearchConfig) this.props.addApiExpertSearchConfig(expertSearchConfig);

                    //Masterupload
                    tempConfig = dataconfig.clipupload;
                    if (tempConfig) this.props.addTempConfig(tempConfig);

                    //MetaData
                    if (!this.props.customConfigClipInfoForApp) {
                        console.log("LAMTEST element.clip", element.clip);
                        this.props.getCustomConfigClipInfoForApp(CustomAppEventListener("convertMetadata", element.clip));
                    }
                });
            } else {
                const appsConfig = appsConfigData.appsConfig;
                this.props.addApiAppsConfig(appsConfigData);

                if (appsConfig && appsConfig.length > 0) {
                    appsConfig.map(app => {
                        const { appId, upload, expertSearch } = app;
                        if (appId === process.env.REACT_APP_APPID) {
                            if (upload.submenu) this.props.addApiUploadConfig(upload.submenu);
                            if (expertSearch.submenu) this.props.addApiExpertSearchConfig(expertSearch.submenu);
                        }
                    })
                }
            }
        } catch (error) {
            console.log("ERROR: appConfig!");
        }

        if (DataUtil.isPMDB()) {
            window.flow.fileGet(CustomTypes.TAGS_FILE)
                .then(res => JSON.parse(res.content))
                .then(obj => { this.props.addApiTags(obj); })
                .catch(e => { console.log(`CustomDataApi could not load "${CustomTypes.TAGS_FILE}"`, e + ''); });

            window.flow.fileGet(CustomTypes.MODELS_FILE)
                .then(res => JSON.parse(res.content))
                .then(obj => { this.props.addApiModels(obj); })
                .catch(e => { console.log(`CustomDataApi could not load "${CustomTypes.MODELS_FILE}"`, e + ''); });
        }

    }
    render() {
        return (<div></div>)
    }
}

const mapStateToProps = (state) => ({
    users: state.admin.users,
    user: state.auth.user,
    customConfigClipInfoForApp: state.customData.customConfigClipInfoForApp
});
const mapDispatchToProps = (dispatch) => {
    return {
        addApiTags: (apiTags) => dispatch(actions.addApiTags(apiTags)),
        addApiModels: (apiModels) => dispatch(actions.addApiModels(apiModels)),
        addApiAppsConfig: (appsConfig) => dispatch(actions.addApiAppsConfig(appsConfig)),
        addApiUploadConfig: (uploadConfig) => dispatch(actions.addApiUploadConfig(uploadConfig)),
        addApiExpertSearchConfig: (expertSearchConfig) => dispatch(actions.addApiExpertSearchConfig(expertSearchConfig)),
        addTempConfig: (tempConfig) => dispatch(actions.addTempConfig(tempConfig)),
        loadUsers: () => dispatch(actions.adminGetUsers()),
        getCustomConfigClipInfoForApp: (data) => dispatch(actions.getCustomConfigClipInfoForApp(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ApiTags);










